import React from 'react';
const IconArrowUndo = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M9.96951 12L7.44951 9H14.4998C16.9851 9 18.9998 11.0147 18.9998 13.5C18.9998 15.9853 16.9851 18 14.4998 18H13.9998V20H14.4998C18.0896 20 20.9998 17.0899 20.9998 13.5C20.9998 9.91015 18.0896 7 14.4998 7H7.44951L9.96951 4H7.35951L3.99951 8L7.35951 12H9.96951Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconArrowUndo;